import React from 'react';
import AdminLayout from "../../layouts/admin/AdminLayout";
import {Box} from "@mui/material";
import ProductsTable from "../../components/admin/products/ProductsTable";
import AuthContext from '../../route/AuthContext';
import {useLocation} from 'react-router-dom';
import BreadcrumbGenerator from '../../components/common/BreadcrumbGenerator';

const Products = () => {

  const {user} = React.useContext(AuthContext);
  const location = useLocation();

  const contentBreadcrumb = BreadcrumbGenerator.generateContent(user?.role ?? '', location.pathname);

  return (
    <AdminLayout
      breadcrumb={contentBreadcrumb}
      title="Prodotti | Piattaforma Innovation ReSearch"
    >
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        mb: 1
      }}>
        <ProductsTable />
      </Box>
    </AdminLayout>
  );
};

export default Products;
